import React from 'react';
import './StoryReel.css';
import Story from './Story';
function StoryReel() {
  return (
    <div className="storyReel">
      <Story
        image="https://scontent-lax3-1.xx.fbcdn.net/v/t1.0-9/934050_594411953915748_2017228358_n.jpg?_nc_cat=104&_nc_sid=cdbe9c&_nc_ohc=2jGAXBYmhaYAX9RwKOb&_nc_ht=scontent-lax3-1.xx&oh=5869eba1e4c6a368139311a9648647dd&oe=5F8AA3AF"
        profileSrc="https://avatars0.githubusercontent.com/u/4778360?s=460&v=4"
        title="Neetish Pathak"
      />
      <Story
        image="https://scontent-lax3-1.xx.fbcdn.net/v/t31.0-8/25438673_813643602140968_8348298072123551949_o.jpg?_nc_cat=102&_nc_sid=e3f864&_nc_ohc=V3RGQOSQLNMAX8XBXWy&_nc_ht=scontent-lax3-1.xx&oh=860729ecd42b420783fd424c9e23bdd4&oe=5F8B40F4"
        profileSrc="https://scontent-lax3-2.xx.fbcdn.net/v/t1.0-9/41585101_1013418872163439_7892239763472646144_o.jpg?_nc_cat=107&_nc_sid=09cbfe&_nc_ohc=dC0CQ9erGuwAX-SdvGn&_nc_ht=scontent-lax3-2.xx&oh=50ca9acd9b521a38467c6de96665fe64&oe=5F8B4A7C"
        title="HS Pathak"
      />
      <Story
        image="https://scontent-lax3-2.xx.fbcdn.net/v/t1.0-9/44994517_761325570879195_1744340283677474816_o.jpg?_nc_cat=106&_nc_sid=e3f864&_nc_ohc=W1BgYyMb-OkAX-p0_Pl&_nc_ht=scontent-lax3-2.xx&oh=45d11e37317bed83a855a3f2758078f2&oe=5F8A6772"
        profileSrc="https://scontent-lax3-2.xx.fbcdn.net/v/t1.0-9/90849221_1131891600489255_5767059777561559040_o.jpg?_nc_cat=111&_nc_sid=09cbfe&_nc_ohc=Yb3A66nljAcAX9DvmNj&_nc_ht=scontent-lax3-2.xx&oh=2c7427e51fa2bfae4abe7ba064d3661f&oe=5F8A7297"
        title="G Pathak"
      />
      <Story
        image="https://scontent-lax3-1.xx.fbcdn.net/v/t31.0-8/11741028_888525614551227_7239242551918164894_o.jpg?_nc_cat=101&_nc_sid=e3f864&_nc_ohc=jH_iJn2WIgQAX-ZnHZs&_nc_ht=scontent-lax3-1.xx&oh=df940970310dc94fde6a7d7c74c55f02&oe=5F8C6470"
        profileSrc="https://scontent-lax3-1.xx.fbcdn.net/v/t1.0-9/75627506_3164381383632294_2990593871462793216_n.jpg?_nc_cat=100&_nc_sid=09cbfe&_nc_ohc=0XdyJwiKJxoAX8zjWjj&_nc_ht=scontent-lax3-1.xx&oh=61c6edc266244ee1457fef2a569956f6&oe=5F8C2A35"
        title="Geetanjali"
      />
      <Story
        image="https://scontent-lax3-2.xx.fbcdn.net/v/t1.0-9/80461942_2325577450876570_9211614069960736768_o.jpg?_nc_cat=111&_nc_sid=84a396&_nc_ohc=gxn0JU9U0OQAX_JI4Nj&_nc_oc=AQmoSG_LnM2JjhOdYcwM_j9XQTuUVQ-VTblocJj6Aygc_hBiVlIsrlwkgxpN8lOLk8A&_nc_ht=scontent-lax3-2.xx&oh=609267a845bd4efadf3235d03af00d75&oe=5F8BB61C"
        profileSrc="https://scontent-lax3-1.xx.fbcdn.net/v/t1.0-9/79367007_454611931917533_922068902232457216_n.jpg?_nc_cat=109&_nc_sid=09cbfe&_nc_ohc=dZC4TUw4fj4AX93VXYl&_nc_ht=scontent-lax3-1.xx&oh=a9d25866d96eed2fada2759b29759d0c&oe=5F8C90F3"
        title="Manini"
      />
      <Story
        image="https://scontent-lax3-1.xx.fbcdn.net/v/t1.0-9/11988317_10208433682907532_913157573053505800_n.jpg?_nc_cat=105&_nc_sid=e3f864&_nc_ohc=E12oWwgazh0AX8wew_x&_nc_ht=scontent-lax3-1.xx&oh=91c104d3066dbe0763e0b1df56c5438f&oe=5F8D1F9F"
        profileSrc="https://scontent-lax3-1.xx.fbcdn.net/v/t1.0-9/65584067_10220126938271608_6646617553059708928_o.jpg?_nc_cat=103&_nc_sid=09cbfe&_nc_ohc=oIJevg8vrhAAX82e7_u&_nc_ht=scontent-lax3-1.xx&oh=428aafeefe84b63e9d08bcf6aa373551&oe=5F8C728B"
        title="Ankur"
      />
      <Story
        image="https://miro.medium.com/max/2160/1*mIy0UkgZHCu7pc6ek07QBw.gif"
        profileSrc="https://scontent-lax3-1.xx.fbcdn.net/v/t1.0-9/88180692_3563988347004927_8638613678318419968_o.jpg?_nc_cat=109&_nc_sid=8bfeb9&_nc_ohc=EsRlMfUOpoEAX8x4wlm&_nc_ht=scontent-lax3-1.xx&oh=22452aab9cf65c32538f9a04af42d86d&oe=5F8C2C4E"
        title="Sia"
      />
    </div>
  );
}

export default StoryReel;
